import React, { useCallback, useState, useMemo, useEffect, useContext } from "react";
//import update from 'immutability-helper';
import { Currency } from "../generated/graphql";
import { asMoney2 } from '../utils';

import {FieldTable} from "./FieldTable/FieldTable";
import { FieldRendererPropsField } from "./FieldTable/FieldTableTypes";


/*
FieldTableDirect, creates a table from a <FieldTableDirect data={data} errors={errors}
columns={columns}/>

Uses [errors] to change the errors and an immutability library to modify the array.

Takes a function as 'children' to render an expanded view.

Allows sorting, editing with focus control etc.  Does not 'unfocus' on blur, meh.

Arguments:
Columns
  accessor: unique name of 'field'
  renderer:({input})=><input {input}/>
  editor: ({input})=><input {input} autoFocus={true}/>  <- it needs to take focus instantly
  sort: the name of the field used for sorting purposes. (could be extended to a function).

 */

type VCVArguments = {
    currency?:Currency,
    value:number
    places?:number,
    qty?:number,
    comma?:boolean,
    showGlyph?:boolean
}

export const variableCurrencyValue = ({currency,value,places,qty,comma, showGlyph=true}:VCVArguments):string => {
    const formattedValue = asMoney2(value * (qty ? qty : 1), places, comma);
    return showGlyph ? (currency?.glyph ?? '') + formattedValue : formattedValue;
};


type VCArguments = {
    field?:FieldRendererPropsField,
    places:number,
    qty?:number
}


export const variableCurrency = ({field,places,qty}:VCArguments):string => {
    return field?.currency?.glyph+asMoney2(field?.value*(qty?qty:1),places);
};


export default React.memo(FieldTable);